export enum VideoItemPanels {
  NONE = 'none',
  SHADOW = 'shadow',
  GLOW = 'glow',
  BORDER = 'border',
  TINT = 'tint',
  MULTIPLY = 'multiply',
  AI_SUBTITLES = 'ai-subtitles',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
}
